import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="multiple-image-preview"
export default class extends Controller {
  static targets = ["input", "previewContainer"];

  readURLs() {
    const input = this.inputTarget;
    const container = this.previewContainerTarget;

    if (input.files && input.files.length > 0) {
      // Clear out the existing previews (so they don't infinitely stack on re-upload)
      container.innerHTML = "";

      // Limit the processing to a maximum of 4 files to match the UI rules
      const filesToProcess = Array.from(input.files).slice(0, 4);

      filesToProcess.forEach((file) => {
        // Safety check to ensure it's actually an image
        if (!file.type.startsWith("image/")) return;

        const reader = new FileReader();

        reader.onload = (e) => {
          // Create the wrapper div with your exact Tailwind classes
          const imgWrapper = document.createElement("div");
          imgWrapper.className =
            "aspect-square rounded-xl overflow-hidden border border-[#0D2D2A]/10 shadow-sm";

          // Create the image element
          const img = document.createElement("img");
          img.src = e.target.result;
          img.className = "w-full h-full object-cover";

          // Assemble and inject into the DOM
          imgWrapper.appendChild(img);
          container.appendChild(imgWrapper);
        };

        reader.readAsDataURL(file);
      });
    }
  }
}
